import {useTestFilterValues} from "./hooks/useTestFilterValues";
import {TestList} from "./TestList";
import {ListFilterValuesContext} from "../../hooks/list/ListFilterValuesContext";
import {VoucherType} from "../../types/voucher";

export function KpassTestListWrapper() {
  const { filterValues, pageInfoOnFilter, searchList, listQueryType } = useTestFilterValues();

  return (
    <ListFilterValuesContext.Provider
      value={{
        filterValues,
        pageInfoOnFilter,
        searchList,
        listQueryType,
      }}
    >
      <TestList testType={VoucherType.KPASS} />
    </ListFilterValuesContext.Provider>
  );
}
